import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faTachometerAlt,
    faCoins,
    faGlobe,
    faUser,
    faExchangeAlt,
    faFile,
    faWrench,
    faExternalLinkAlt,
    faInfoCircle,
    faClipboardList,
    faPlusCircle,
    faMinusCircle,
    faCopy,
    faArrowUp,
    faPassport,
    faLayerGroup,
    faUniversity,
    faArrowDown,
    faPlug,
    faServer,
    faDatabase,
    faHdd,
    faWifi,
    faTerminal,
    faTasks,
    faEnvelope,
    faSyncAlt,
    faCreditCard,
    faCodeBranch,
    faSignOutAlt,
    faClock, faCheck, faExclamation,
    faFlag, faGift,
    faHandHoldingUsd,
    faCircle,
    faShieldAlt,
    faNewspaper,
    faUserFriends
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from "vue";

library.add(faTachometerAlt)
library.add(faCoins)
library.add(faGlobe)
library.add(faUser)
library.add(faWrench)
library.add(faExchangeAlt)
library.add(faExternalLinkAlt)
library.add(faInfoCircle)
library.add(faFile)
library.add(faClipboardList)
library.add(faPlusCircle)
library.add(faMinusCircle)
library.add(faCopy);
library.add(faArrowUp)
library.add(faArrowDown)
library.add(faPassport)
library.add(faLayerGroup)
library.add(faUniversity)
library.add(faPlug)
library.add(faServer)
library.add(faServer)
library.add(faDatabase)
library.add(faHdd)
library.add(faWifi)
library.add(faTerminal)
library.add(faTasks)
library.add(faEnvelope)
library.add(faSyncAlt)
library.add(faCreditCard)
library.add(faCoins)
library.add(faCodeBranch)
library.add(faSignOutAlt)
library.add(faClock)
library.add(faCheck)
library.add(faExclamation)
library.add(faCircle)
library.add(faFlag)
library.add(faGift)
library.add(faHandHoldingUsd)
library.add(faShieldAlt)
library.add(faNewspaper)
library.add(faUserFriends)


Vue.component('font-awesome-icon', FontAwesomeIcon)
